// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationFR from '../locales/fr/translation.json';
import translationAR from '../locales/ar/translation.json';

const resources = {
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // default language
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

export default i18n;
